"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelephoneInput = void 0;
const React = require("react");
const Keypad_1 = require("../../atoms/Keypad");
const BaseInput_1 = require("../BaseInput");
const KeypadWrapper_1 = require("../../atoms/KeypadWrapper");
/**
 * Number input
 */
class TelephoneInput extends BaseInput_1.BaseInput {
    constructor(props) {
        super(props);
        // digits, spaces, brackets, and the plus symbol are allowed
        this.bannedValuesRegex = /[^\d\s\(\)\+]/g;
        // HACK these are to support Helix - DO NOT CHANGE without testing against Helix
        // manually add phone number formatters
        this.preparedFormatters = [
            {
                // 04xxxxxxxx -> 04xx xxx xxx
                pattern: /^(04\d{2})\s*(\d{0,3})\s*(\d{0,3})(.*)/,
                blueprint: "$1 $2 $3",
                filter: /[\s-]+$/,
                type: "pattern"
            },
            {
                // +?614xxxxxxxx -> 04xx xxx xxx
                pattern: /^(\+?61)(4\d{2})(\d{3})(\d{3})(.*)/,
                blueprint: "0$2 $3 $4",
                filter: /[\s-]+$/,
                type: "pattern"
            },
            {
                pattern: /^\(?(02|03|07|08)\)?\s*(\d{4})\s*(\d{4})(.*)/,
                blueprint: "($1) $2 $3",
                filter: /[\s-]+$/,
                type: "pattern"
            }
        ];
    }
    componentDidMount() {
        // on first render, simulate an input being changed so the base input runs the formatting.
        if (this.props.value) {
            this.onInputChange(this.props.value);
        }
    }
    render() {
        const { value, placeholder, disabled, readonly = true, hint, hideKeypad = false } = this.props;
        /**
         * If hideKeypad (hide the custom keypad, not the native) is true, we want to show the native keyboard.
         */
        const readOnlyValue = readonly && hideKeypad === false ? true : null;
        let input = (React.createElement("input", { "data-test": "input", "data-hint": hint, type: "tel", onChange: evt => this.onInputChange(evt.target.value), value: value || "", placeholder: placeholder, disabled: disabled, readOnly: readOnlyValue }));
        return hideKeypad ? (input) : (React.createElement(KeypadWrapper_1.KeypadWrapper, { inputComponent: input, keypadComponent: React.createElement(Keypad_1.NumberKeypad, null) }));
    }
}
exports.TelephoneInput = TelephoneInput;
//# sourceMappingURL=index.js.map